module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/cybermonday-bg.8f17e82a.png";